export const $TranslationsModuleName = "translations";

export type TTranslation = {
    [key: string]: string;
};

export type TTranslationsState = {
    debug: boolean;
    data?: TTranslation;
};
